export default {"src":"/_next/static/media/youtube-icon.9cf0e3d9.svg","height":96,"width":137};